import React, { useEffect, useState } from "react";
import { Card, Div, Text } from "../../../styles/Common";
import { theme } from "../../../styles/theme";
import { Button } from "../../../components/Button";
import { Link } from "../../../components/Link";
import arrowRight from "../../../assets/icons/arrow-right-salmon.svg";
import { UserCard } from "../styles";
import { useNavigate } from "react-router-dom";
import { AddUserToProjectModal } from "../../Projects/components/AddUserToProjectModal";
import useGetRoles from "../hooks/useGetRoles";
import useGetActiveUsers from "../hooks/useGetActiveUsers";
import trashIcon from "../../../assets/icons/trash.svg";
import { Alert } from "antd";

export const UsersList = ({
  userRolesProject,
  setUserRolesProject,
  projectId,
  usersInfo,
  setUsersInfo,
  source,
  editProject,
  hasNewUsers,
  initialUserRolesProject = [],
}) => {
  const navigate = useNavigate();
  const getRoles = useGetRoles();
  const { data, isSuccess } = getRoles;
  const [rolesOptions, setRolesOptions] = useState([]);
  const getActiveUsers = useGetActiveUsers();
  const { data: activeUsers, isSuccess: isActiveUsersSuccess } = getActiveUsers;
  const [activeUsersOptions, setActiveUsersOptions] = useState([]);
  const [openCreate, setOpenCreate] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setRolesOptions(data?.data?.roles.map((ele) => ({
        value: ele.id,
        label: ele.name
      })));
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (isActiveUsersSuccess) {
      setActiveUsersOptions(activeUsers?.data?.getActiveUsers.map((ele) => ({
        value: ele.id,
        label: ele.name
      })));
    }
  }, [activeUsers, isActiveUsersSuccess]);

  const handleViewAllUsers = () => {
    navigate(`/projects/users/${projectId}`);
  };

  const handleAddUser = () => {
    setOpenCreate(true);
  };

  const handleClose = () => {
    setOpenCreate(false);
    setUsersInfo([
      {
        id: 1,
        userId: "",
        role: "",
      }
    ]);
  };

  const getRoleName = (roleId) => {
    return rolesOptions.find((role) => role.value === roleId)?.label;
  };

  const getUserName = (userId) => {
    return activeUsersOptions.find((user) => user.value === userId)?.label;
  };

  const handleDeleteUser = (index) => {
    const updatedUserRoles = userRolesProject.filter((_, i) => i !== index);
    setUserRolesProject(updatedUserRoles);
  };

  const isNewUser = (user, index) => {
    if (source === "create") {
      return true;
    }
    
    return index >= initialUserRolesProject.length;
  };

  return (
    <Card 
      width="37%" 
      style={{ padding: "25px 34px 24px 25px", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}
    >
      <AddUserToProjectModal
        openCreate={openCreate}
        handleClose={handleClose}
        usersInfo={usersInfo}
        setUsersInfo={setUsersInfo}
        rolesOptions={rolesOptions}
        activeUsersOptions={activeUsersOptions}
        setUserRolesProject={setUserRolesProject}
        userRolesProject={userRolesProject}
        source="createProject"
        projectId={projectId}
        refetch={null}
      />
      <Div width="100%" justify="space-between" align="center" height="40px">
        <Text
          size={theme.fonts.size.h6}
          weight={theme.fonts.weight.medium}
          color={theme.colors.dark}
        >
          Project Users
        </Text>
        {source !== "create" && userRolesProject?.length > 0 && (
          <Link onClick={handleViewAllUsers}>
            <Div direction="row" align="center" gap="8px">
              View all Users
              <img src={arrowRight} alt="arrow-right" />
            </Div>
          </Link>
        )}
      </Div>
      {editProject && hasNewUsers && (
        <Alert
          message="To save the added users, you need to save the project changes. If you leave this page without updating, you will lose the added users."
          type="warning"
        />
      )}
      <Div height="100%" width="100%">
        {userRolesProject?.length > 0 ? (
          <Div direction="column" width="100%" m="32px 0 0 0" justify="space-between">
            <Div direction="column" gap="8px" style={{ overflowY: "auto", maxHeight: hasNewUsers ? "350px" : "400px" }}>
              {userRolesProject.map((user, index) => (
                <UserCard key={index}>
                  <Div direction="column" gap="1px">
                    <Text color={theme.colors.grey1}>{getUserName(user.userId)}</Text>
                    <Text size={theme.fonts.size.sm} color={theme.colors.grey2}>{getRoleName(user.roleId)}</Text>
                  </Div>
                  {isNewUser(user, index) && (
                    <img src={trashIcon} alt="trash" style={{ cursor: "pointer" }} onClick={() => handleDeleteUser(index)} />
                  )}
                </UserCard>
              ))}
            </Div>
            {editProject && (
              <Div width="100%" justify="center">
                <Button background={theme.colors.salmon} onClick={handleAddUser}>
                  Add users
                </Button>
              </Div>
            )}
          </Div>
        ) : (
          <Div direction="column" height="100%" justify="center" align="center">
            <Text
              weight={theme.fonts.weight.medium}
              color={theme.colors.dark}
              mb="32px"
            >
              No users added to this project yet
            </Text>
            <Text
              size={theme.fonts.size.sm}
              color={theme.colors.grey1}
              align="center"
              mb="23px"
            >
              Assign team members to give them access and start collaborating. To assign multiple roles, add the user separately for each role.
            </Text>
            {editProject && (
              <Button background={theme.colors.salmon} onClick={handleAddUser}>
                Add users
              </Button>
            )}
          </Div>
        )}
      </Div>
    </Card>
  )
};
